"use strict";import{tag as t}from"../custom-tag.js";export function eyeClosedIcon({height:e=16,width:l=16,hidden:a=!1,title:s="Eye closed"}={}){return t`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${s}"
    >
      <mask
        id="eye-closed_svg__mask0_6875_6291"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12 4.046a9.9 9.9 0 0 0-3.08.493l-.527.173.346 1.056.53-.173A8.7 8.7 0 0 1 12 5.158a9.54 9.54 0 0 1 8.86 6.71 10.5 10.5 0 0 1-1.82 3.279l-.354.43.86.705.353-.43a11.6 11.6 0 0 0 2.074-3.814.56.56 0 0 0 0-.342A10.66 10.66 0 0 0 12 4.046m-9.867-1.26L5.68 6.333a11.35 11.35 0 0 0-3.653 5.363.56.56 0 0 0 0 .342A10.66 10.66 0 0 0 12 19.688a9.9 9.9 0 0 0 5.42-1.616l3.662 3.662.786-.786L2.919 2zm7.87 7.869 3.21 3.21a2.33 2.33 0 0 1-3.21-3.21m-.81-.809a3.457 3.457 0 0 0 4.828 4.828l2.575 2.575A8.77 8.77 0 0 1 12 18.576a9.54 9.54 0 0 1-8.86-6.709 10.24 10.24 0 0 1 3.325-4.75z"
        />
        <mask
          id="eye-closed_svg__mask1_6875_6291"
          width="8"
          height="8"
          x="7"
          y="9"
          maskUnits="userSpaceOnUse"
          style="mask-type:alpha"
        >
          <path fill="currentColor" d="M9.879 9.121 7 12l5 5 2.879-2.879z" />
        </mask>
        <g mask="url(#eye-closed_svg__mask1_6875_6291)">
          <circle cx="12" cy="12" r="3" fill="currentColor" />
        </g>
      </mask>
      <g mask="url(#eye-closed_svg__mask0_6875_6291)">
        <path fill="currentColor" d="M24-.007H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=eyeClosed.js.map
